module.exports = __webpack_public_path__ + "img/mega_4.7701883b.png";